module.exports = __webpack_public_path__ + "static/media/nine.e2a57275.svg";